import { ConflictError } from "./conflict-error";

// Thrown by the cancel guard when an order has moved past the point where withdrawing it is
// clean — anything other than `open` or `pending`. Once a suborder reaches `picking`, stock has
// left shelves and `orderArticles."pickedQuantity"` records it, so releasing the order's claim
// there would give the shelf back an amount that is no longer standing on it. 409: the request is
// well formed, it is the order that has moved on since the screen last read it.
export class OrderNotCancellableError extends ConflictError {
	constructor() {
		super("stock.order_not_cancellable");
		this.name = "OrderNotCancellableError";
	}
}
